import Immutable from 'immutable';
import { HOME_PATH, LEGAL_CARGO_PATH, LEGAL_MANIFEST_BAGGAGE_PATH, LEGAL_MANIFEST_CARGO_PATH, LEGAL_MANIFEST_TICKET_PATH, LEGAL_TICKET_PATH } from '../../../config/paths';

const INITIAL_STATE = Immutable.Map({
  cards: [
    {
      key: 'legal-cargo',
      title: 'Carga',
      path: LEGAL_CARGO_PATH,
      icon: 'archive',
    },
    {
      key: 'legal-ticket',
      title: 'Boletos',
      path: LEGAL_TICKET_PATH,
      icon: 'ticket'
    },
    {
      key: 'legal-manifest-cargo',
      title: 'Manifiesto de Carga',
      path: LEGAL_MANIFEST_CARGO_PATH,
      icon: 'paste',
    },
    {
      key: 'legal-manifest-ticket',
      title: 'Manifiesto de Pasajeros',
      path: LEGAL_MANIFEST_TICKET_PATH,
      icon: 'bus'
    },
    {
      key: 'legal-manifest-baggage',
      title: 'Manifiesto de Equipaje',
      path: LEGAL_MANIFEST_BAGGAGE_PATH,
      icon: 'suitcase'
    }
  ],
  breadcrumbs: [
    {
      text: 'Inicio',
      tag: 'a',
      href: HOME_PATH,
    },
    {
      text: 'Gestión Legal',
      tag: 'span',
      href: '/legal',
    },
  ],
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    default:
      return state;
  }
};


